import './ApiKeysList.scss';
import React, { useEffect, useState } from 'react';
import DataTable from 'src/component/UI/DataTable';
import { useSelector, useDispatch } from 'react-redux';

import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { Tooltip } from '@mui/material';
import { getTablePagePreferences } from 'src/module/authentication/selector';
import { getApiKeys, getLoadingApiKeys, getNumApiKeysPages, getTotalApiKeys } from 'src/module/apiKeys/selector';
import { fetchApiKeys, deleteApiKey } from 'src/module/apiKeys/action';
import PermissionFence from 'src/component/PermissionFence';

export default function ApiKeysList () {
  const dispatch: any = useDispatch();
  const userPagePreference = useSelector(getTablePagePreferences('api-keys'));

  const apiKeys: any = useSelector(getApiKeys);
  const numPages: any = useSelector(getNumApiKeysPages);
  const totalKeys: any = useSelector(getTotalApiKeys);
  const loading: any = useSelector(getLoadingApiKeys);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(userPagePreference);
  const [sort, setSort] = useState(null);

  const deleteRec = (e, id) => {
    e.stopPropagation();
    dispatch(deleteApiKey(id));
  };

  const columnOptions: any = [
    {
      id: 'created_at',
      Header: 'Created At',
      accessor: (row: any) => row?.getIn(['created_at']) || '',
      sortable: true
    },
    {
      id: 'last_used_at',
      Header: 'Last Used At',
      accessor: (row: any) => row.get('last_used_at') || 'Never',
      sortable: true
    },
    {
      id: 'permission_level',
      Header: 'Permission Level',
      accessor: (row: any) => row.get('permission_level'),
      disableSortBy: true
    },
    {
      id: 'actions',
      Header: '',
      accessor: (row: any) => row.id,
      disableSortBy: true,
      Cell: (row: any) => <div className='actions-container'>
        <PermissionFence can={['edit-api-key']} >
          <>
            <Tooltip title="Delete Api Key" placement="top">
              <div onClick={(e) => deleteRec(e, row.row.original.get('id'))}>
                <DeleteIcon className='delete-icon'/>
              </div>
            </Tooltip>
          </>
        </PermissionFence>
      </div>
    }
  ];

  useEffect(() => {
    dispatch(fetchApiKeys({ paginationDetails: { page, pageSize, sort } }));
  }, [dispatch, page, pageSize, sort]);

  const fetchPage = (_page, _pageSize, _filter, _sort) => {
    setPage(_page);
    setPageSize(_pageSize);
    setSort(_sort);
  };

  return (
    <div id='api-keys-list' className='api-keys-list' >
      <DataTable
        columns={columnOptions}
        data={apiKeys}
        pagination={true}
        numPages={numPages}
        totalRecords={totalKeys}
        loading={loading}
        fetchPage={fetchPage}
        tableId='api-keys'
        columnWidths={['30%', '30%', '30%', '10%']}
        hoverBorder={true}
      />
    </div>
  );
}
